import React, { useState } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import healthcareImg from "../../assets/s3.png";

import { FaRobot, FaHeartbeat } from "react-icons/fa";

const styles = `
  .hc-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .hc-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .hc-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .hc-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .hc-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hc-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .hc-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .hc-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .hc-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .hc-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .hc-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .hc-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .hc-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .hc-img-wrapper {
    flex: 1;
  }

  .hc-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .hc-accordion {
    flex: 1.2;
  }

  .hc-accordion-item {
    margin-bottom: 18px;
  }

  .hc-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .hc-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .hc-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .hc-header {
      height: auto;
      min-height: 90px;
    }

    .hc-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .hc-title-group h2 {
      font-size: 26px;
    }

    .hc-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .hc-header {
      flex-direction: column;
      height: auto;
    }

    .hc-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .hc-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .hc-triangle-left,
    .hc-triangle-right {
      width: 50px;
    }

    .hc-title-group h2 {
      font-size: 22px;
    }

    .hc-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .hc-img-wrapper {
      width: 100%;
    }

    .hc-img-wrapper img {
      max-width: 100%;
    }

    .hc-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .hc-header {
      flex-direction: column;
      height: auto;
    }

    .hc-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .hc-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .hc-header-badge span:first-of-type {
      font-size: 12px;
    }

    .hc-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .hc-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .hc-triangle-left,
    .hc-triangle-right {
      width: 36px;
    }

    .hc-title-group h2 {
      font-size: 18px;
    }

    .hc-title-group svg {
      font-size: 24px !important;
      flex-shrink: 0;
    }

    .hc-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .hc-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .hc-accordion-arrow {
      font-size: 18px;
    }

    .hc-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .hc-title-group h2 {
      font-size: 15px;
    }

    .hc-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function HealthcarePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Simplifying patient appointment scheduling",
      content:
        "Bots can automate patient data collection and processing and can optimally schedule patient appointments according to diagnosis, location, doctor availability, and other standards."
    },
    {
      title: "2.Speeding up account settlements",
      content:
        "RPA bots can precisely estimate the bill amount considering the costs for tests, medicines, wardroom, food, and doctor fees. And software can inform patients of their bill amount and payments."
    },
    {
      title: "3.Implementing discharge instructions",
      content:
        "RPA can ensure the discharge guidelines and send reminders to patients about prescription pick-ups. And notify their patients about upcoming doctor's appointments and medical tests."
    },
    {
      title: "4.Recording audit procedures",
      content:
        "RPA helps to record data and generate reports during audits. The reports can be robotically shared with concerned parties for evaluation and approval."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="hc-header">
        {/* LEFT */}
        <div
          className="hc-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="hc-header-overlay" />

          <div className="hc-header-badge">
            <div className="hc-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>

            <span className="hc-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="hc-header-right">
          <div className="hc-triangle-left" />
          <div className="hc-triangle-right" />

          <div className="hc-title-group">
            <FaHeartbeat style={{ fontSize: "32px", color: "#2fb7a4" }} />
            <h2>Healthcare</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="hc-main">
        {/* IMAGE */}
        <div className="hc-img-wrapper">
          <img src={healthcareImg} alt="Healthcare" />
        </div>

        {/* ACCORDION */}
        <div className="hc-accordion">
          {data.map((item, i) => (
            <div key={i} className="hc-accordion-item">
              <div
                className="hc-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="hc-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="hc-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HealthcarePage;
